module.exports = __webpack_public_path__ + "img/nav-m-4.1ee6de45.png";